import { ReactElement } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { TableColumnUI } from './TableColumnUI'
import { TableRowUI } from './TableRowUI'
import { t } from 'i18next'
import DevelopusMoreButton from '../button/DevelopusMoreButton'
import { UUID } from 'crypto'
import { TableColumnsUI } from './TableColumnsUI'
import { TableRowsUI } from './TableRowsUI'

type Props = {
  columnsUI: TableColumnsUI
  rowsUI: TableRowsUI
  handleEdit: (id: UUID) => void
  handleRemove: (id: UUID) => void
}

const DevelopusTable = ({
  handleEdit,
  handleRemove,
  columnsUI,
  rowsUI,
}: Props): ReactElement => {
  return (
    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          {columnsUI.columns.map((column: TableColumnUI) => (
            <TableCell key={column.id} sx={{ width: column.width }}>
              {t(`${column.text}`)}
            </TableCell>
          ))}
          <TableCell sx={{ width: 30 }}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rowsUI.rows.map((rowUI: TableRowUI) => (
          <TableRow
            key={rowUI.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            {columnsUI.columns.map((column: TableColumnUI) => (
              <TableCell key={column.id}>{rowUI.row[column.id]}</TableCell>
            ))}
            <TableCell>
              <DevelopusMoreButton
                handleEdit={() => handleEdit(rowUI.id)}
                handleRemove={() => handleRemove(rowUI.id)}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default DevelopusTable
